import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_SITE_URL = 'https://nitrologs.com';
const DEFAULT_IMAGE = `${DEFAULT_SITE_URL}/nitrologs.png`;
const DEFAULT_KEYWORDS = 'verified social media accounts, virtual numbers, SMS verification, social media boosting, secure payments, Nitro Logs';

const getPageUrl = (pageUrl) => {
  if (pageUrl) {
    return pageUrl;
  }

  if (typeof window !== 'undefined') {
    return window.location.href;
  }

  return DEFAULT_SITE_URL;
};

export const SeoHead = ({
  title,
  description,
  keywords = DEFAULT_KEYWORDS,
  pageUrl,
  imageUrl = DEFAULT_IMAGE,
  imageAlt = 'Nitro Logs social media services',
  type = 'website',
  schema = null,
}) => {
  const canonicalUrl = getPageUrl(pageUrl);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="theme-color" content="#0B1120" />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:site_name" content="Nitro Logs" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      <link rel="canonical" href={canonicalUrl} />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};
